import Dashboard from "../views/Dashboard/Dashboard.js";
import HistoryMapPage from "../views/HistoryMap/HistoryMap";
import PipesSeriesPage from "../views/PipesSeries/PipesSeries";
import BookIcon from "@material-ui/icons/Book";
import DashboardIcon from "@material-ui/icons/Dashboard";

export const dashboardAndOthers = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: DashboardIcon,
    component: Dashboard,
    layout: "/admin",
    inSidebar: true,
    isProtected: false,
  },
  {
    path: "/ordenes_mapa",
    name: "Ordenes Mapa",
    icon: BookIcon,
    component: HistoryMapPage,
    layout: "/maps",
    inSidebar: false,
    isProtected: false,
  },
  {
    path: "/serie_pipas",
    name: "Serie de Pipas",
    icon: BookIcon,
    component: PipesSeriesPage,
    layout: "/admin",
    inSidebar: true,
    isProtected: true,
    rule: "SERIES",
  },
]